export default __webpack_public_path__ + "static/media/sara.70471cef.png";